export enum FormKeys {
    PackName = 'name',
    Description = 'description',
    LabelName = 'label',
    PackGenre = 'genres',
    PackSubgenre = 'subgenres',
    Exclusivity = 'exclusive',
    Lexicon = 'lexicon',
}
